const actions = {
	signup: 'signup', // affiliate is registered
	signin: 'signin', // affiliate is authorized
	login: 'login' // affiliate is logged in
};

const locale = {
	ru: actions,
	en: actions,
	uk: actions,
	de: actions,
	vi: actions,
	th: actions
};

module.exports = {
	enum: actions,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/dashboard-visit-actions.js